import React from "react";
import FatehLogo from "../Assets/KPS_Logo.png";

const PrintInterviewSlip = React.forwardRef(({ data }, ref) => {
  if (!data) return null;

  const formatDate = (date) => (date ? date.slice(0, 10) : "");
  const academicYear = `${new Date().getFullYear()}-${new Date().getFullYear() + 1}`;

  return (
    <>
      <style>{`
  @page { size: A5 landscape; margin: 2mm; }
  @media print {
    body { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  }
`}</style>

      <div ref={ref} className="p-1 text-[10px] text-black leading-tight">

        <div className="flex justify-between items-center border-b-2 border-black pb-2 mb-2">
          <div className="flex items-center gap-3 w-3/4">
            <img src={FatehLogo} alt="logo" className="w-16" />
            <div className="text-center">
              <h1 className="text-3xl font-bold tracking-wide">FATEHPUR PUBLIC SCHOOL</h1>
              <p className="text-[12px] font-medium">251, Baqar Ganj, Fatehpur – 212601</p>
              <p className="text-[12px] font-bold uppercase tracking-wider">
                INTERVIEW ACKNOWLEDGEMENT SLIP ({academicYear})
              </p>
            </div>
          </div>

          <div className="text-center border-2 border-black p-1">
            <div className="w-[28mm] h-[34mm] border border-black flex items-center justify-center">
              <span className="text-[8px] text-center">Affix Student Photo</span>
            </div>
          </div>
        </div>

        <div className="border-2 border-black p-2 mb-2 text-[11px] font-bold text-center">
          Interview Date: {data.InterviewDate} &nbsp; | &nbsp;
          Time: {data.InterviewTime} &nbsp; | &nbsp;
          Ref No: {data.RefNo}
        </div>

        <div className="row border border-black p-2 mb-1">
          <h2 className="font-bold border-b border-black mb-1 text-center">STUDENT DETAILS</h2>
          <div className="col-6 mb-1">
            <DetailField label="Full Name" value={data.Name} />
          </div>
          <div className="col-3 mb-1">
            <DetailField label="DOB" value={formatDate(data.DOB)} />
          </div>
          <div className="col-3 mb-1">
            <DetailField label="Gender" value={data.Gender} />
          </div>
          <div className="col-6 mb-1">
            <DetailField label="Father's Name" value={data.FatherName} />
          </div>
          <div className="col-3 mb-1">
            <DetailField label="Mother's Name" value={data.MotherName} />
          </div>
          <div className="col-3 mb-1">
            <DetailField label="Mobile" value={data.Whatsapp} />
          </div>
          <div className="col-12 mb-1">
            <DetailField label="Address" value={data.Address} fullWidth />
          </div>
        </div>

        <div className="border border-black p-2 text-[9px] leading-snug">
          <h2 className="font-bold border-b border-black mb-1 text-center">INTERVIEW & ADMISSION DETAILS</h2>
          <ol className="list-decimal ml-4 space-y-0.5">
            <li><b>Interview Venue:</b> Fatehpur Public School, Baqar Ganj, G.T. Road, Fatehpur.</li>
            <li>Use the reference number to check interview details on school website.</li>
            <li><b>Age Requirement:</b> Child must be 3–4 years old.</li>
            <li>
              <b>Documents Required:</b> Aadhaar copy of parents &
              <b> valid Birth Certificate of child</b> (certificate should be government-issued,
              preferably with QR code / online verifiable record. Birth certificates generated
              by government hospitals or municipal authorities are accepted).
            </li>
            <li>Preference given to siblings studying in school.</li>
            <li>School does not provide transport facility.</li>
          </ol>
        </div>

        <div className="border-t-2 border-black mt-6">
          <div className="flex justify-between">
            <div className="text-center w-1/3">
              <div className="h-10 border-b-2 border-black w-36 mx-auto"></div>
              <p className="text-[9px] font-semibold mt-1">Parent's Signature</p>
            </div>

            <div className="text-center w-1/3">
              <div className="h-10 border-b-2 border-black w-36 mx-auto"></div>
              <p className="text-[9px] font-semibold mt-1">Principal's Signature</p>
            </div>
          </div>
        </div>

        <p className="text-center text-[8px] italic mt-1">
          Please bring this slip along with required documents on the interview date.
        </p>
      </div>

    </>
  );
});

const DetailField = ({ label, value, fullWidth = false }) => (
  <div className={`flex items-center border-b border-dark-200 py-0.5 ${fullWidth ? 'col-span-2' : ''}`}>
    <span className="font-medium min-w-[80px] text-[9px]">{label}:</span>
    <span className="ml-1 text-[10px] font-normal flex-1 truncate pb-0.5">
      {value}
    </span>
  </div>
);

export default PrintInterviewSlip;